import { Box, Divider, Typography } from '@mui/material';
import PageHeader from 'components/Header/Page';
import React, { useEffect, useState } from 'react';
import LoaderComponent from 'components/Loader';
import Insights from './Insights';
import CalenderIcon from '../../assets/mdi_calendar.svg';
import { addOrUpdateInsights, deleteInsights, getInsights } from 'service/service';
import moment from 'moment';
import PageWrapper from 'components/Common/PageWraper';
import HighlightedText from 'components/GlobalSearch/HighlightText';
import YearMonthPicker from 'components/Dropdown/YearMonthPicker';

const TopicOfTheMonth = () => {
	const isXOps = true;
	const getInitialMonth = () => {
		return isXOps ? moment().subtract(1, 'month').format('YYYY-MM') : '0M';
	};
	const [customMonth, setCustomMonth] = useState(getInitialMonth());
	const [filterMonth, setFilterMonth] = useState(getInitialMonth());

	const [insights, setInsights] = useState<Insights[]>([]);
	const [loader, setLoader] = useState<boolean>(false);
	interface Insights {
		insightId: number;
		title: string;
		description: string;
		opsType: string;
		createdBy: string;
		updatedBy: string;
		createdDate: string;
		updatedDate: string;
	}

	//Function to fetch insights
	const fetchInsights = async (selectedMonth: string) => {
		setLoader(true);
		try {
			const response = await getInsights('Topic of the Month', '', selectedMonth);
			if (response.success) {
				setInsights(response.data.data);
				setLoader(false);
				console.log('response', response);
			} else {
				setLoader(false);
			}
		} catch (error) {
			console.error('Failed to get insights:', error);
		}
	};

	// Fetch insights
	useEffect(() => {
		fetchInsights(filterMonth);
	}, []);

	// Function to handle adding a new insight
	const handleAddInsight = async (newInsight: any) => {
		try {
			setLoader(true);
			const response = await addOrUpdateInsights({
				title: newInsight?.title,
				xopsType: 'Topic of the Month',
				description: newInsight?.description
			});
			if (response.success) {
				console.log('response', response);
				fetchInsights(filterMonth);
			} else {
				setLoader(false);
			}
		} catch (error) {
			console.error('Failed to add insight:', error);
		}
	};

	// Function to handle updating an insight
	const handleUpdateInsight = async (updatedInsight: any) => {
		try {
			setLoader(true);
			const response = await addOrUpdateInsights({
				title: updatedInsight?.title,
				xopsType: 'Topic of the Month',
				description: updatedInsight?.description,
				insight_id: updatedInsight?.id
			});
			if (response.success) {
				console.log('response', response);
				fetchInsights(filterMonth);
			} else {
				setLoader(false);
			}
		} catch (error) {
			console.error('Failed to update insight:', error);
		}
	};

	// Function to handle deleting an insight
	const handleDeleteInsight = async (insightId: number) => {
		try {
			setLoader(true);
			const response = await deleteInsights(insightId);
			if (response.success) {
				console.log('response', response);
				fetchInsights(filterMonth);
			} else {
				setLoader(false);
			}
		} catch (error) {
			console.error('Failed to delete insight:', error);
		}
	};

	const handleDateChange = (selectedDate: string) => {
		fetchInsights(selectedDate);
	};


	return (
		<PageWrapper>
			<PageHeader title="Topic of the Month" icon={CalenderIcon}>
				<YearMonthPicker
					customMonth={customMonth}
					filterMonth={filterMonth}
					setCustomMonth={setCustomMonth}
					setFilterMonth={setFilterMonth}
					handleChange={handleDateChange}
				/>
				{/* <DateFilterDropdown
					customMonth={customMonth}
					filterMonth={filterMonth}
					setCustomMonth={setCustomMonth}
					setFilterMonth={setFilterMonth}
					handleChange={handleDateChange}
					isXOps={true}
				/> */}
			</PageHeader>
			<Box marginTop={4} px={{ xs: 1, md: 2, lg: 3 }} id="insights">
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
					<Typography variant="subHeader" sx={{ color: '#009BDB' }}>{<HighlightedText text="Insights/Actions" />}</Typography>
					<Divider sx={{ flexGrow: 1, backgroundColor: '#009BDB', marginLeft: 2 }} />
				</Box>
				<Typography
					variant="bodyText"
					sx={{ fontStyle: 'italic', color: '#71758F', marginBottom: 5 }}
				>
					You can display and update Insights/Actions if any.
				</Typography>
			</Box>
			{loader ? (
				<LoaderComponent />
			) : (
				<Box sx={{ mb: 3 }}>
					<Insights
						insights={insights}
						setInsights={setInsights}
						onAdd={handleAddInsight}
						onUpdate={handleUpdateInsight}
						onDelete={handleDeleteInsight}
					/>
				</Box>
			)}
		</PageWrapper>
	);
};
export default TopicOfTheMonth;
